const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';
// Sanctum の CSRF Cookie エンドポイントは /api プレフィックスなし
const BASE_URL = SERVER_URL.replace(/\/api$/, '');

export interface User {
  id: number;
  name: string;
  email: string;
}

interface AuthResponse {
  data: User;
}

/**
 * Sanctum CSRF Cookie を取得（ログイン前に必要）
 */
export async function getCsrfCookie(): Promise<void> {
  await fetch(`${BASE_URL}/sanctum/csrf-cookie`, {
    credentials: 'include',
  });
}

/**
 * ログイン
 */
export async function login(email: string, password: string): Promise<User> {
  await getCsrfCookie();

  // CSRF トークンを Cookie から取得
  const xsrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];

  const response = await fetch(`${SERVER_URL}/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(xsrfToken ? { 'X-XSRF-TOKEN': decodeURIComponent(xsrfToken) } : {}),
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw {
      status: response.status,
      message: errorData?.error?.message || 'ログインに失敗しました',
    };
  }

  const result: AuthResponse = await response.json();
  return result.data;
}

/**
 * ログアウト
 */
export async function logout(): Promise<void> {
  const xsrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];

  await fetch(`${SERVER_URL}/logout`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      ...(xsrfToken ? { 'X-XSRF-TOKEN': decodeURIComponent(xsrfToken) } : {}),
    },
  });
}

/**
 * ログイン中のユーザー情報を取得
 */
export async function getUser(): Promise<User | null> {
  try {
    const response = await fetch(`${SERVER_URL}/user`, {
      credentials: 'include',
      headers: { 'Accept': 'application/json' },
    });

    if (!response.ok) return null;

    const result: AuthResponse = await response.json();
    return result.data;
  } catch {
    return null;
  }
}
